// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/design-tokens.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/dlc-tokens.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/modal-variants.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/modal-toolbar.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/mobile.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

*:not(input):not(textarea):not([contenteditable="true"]) {
  user-select: none;
  -webkit-user-select: none;
}

/* Always-on text selection for lesson bodies + concept card bodies + slide
   content tables. Edward 2026-05-24: "make all the content copy-able."
   The global \`* { user-select: none }\` reset above is intentional for
   game-UI surfaces (cards, pills, dashboard chrome), but study content
   (the actual lesson text and table cells the user is reading) must be
   selectable so it can be copied to notes / external tools. */
.ls-content-body,
.ls-content-body *,
.ls-content-title,
.ls-key-points,
.ls-key-points *,
.ls-markdown,
.ls-markdown *,
.cc-title,
.cc-description,
.cc-origin,
.cc-meta-strip,
.cc-meta-strip *,
.element-table,
.element-table *,
.element-table-wrapper,
.element-table-wrapper *,
.ls-table,
.ls-table * {
  user-select: text;
  -webkit-user-select: text;
}

/* Concept builder mode: allow text selection on slide content + every
   descendant. Without the \`*\` selectors the global * { user-select: none }
   reset wins for child elements (ul/li/p/span), making selection invisible
   even though the wrapper allows it. */
body.cb-text-select .slide-content,
body.cb-text-select .slide-content *,
body.cb-text-select .element-text,
body.cb-text-select .element-text *,
body.cb-text-select .ls-content-block,
body.cb-text-select .ls-content-block *,
body.cb-text-select .ls-slide-block,
body.cb-text-select .ls-slide-block *,
body.cb-text-select .element-definition-list,
body.cb-text-select .element-definition-list *,
body.cb-text-select .diagram-label,
body.cb-text-select .diagram-label *,
body.cb-text-select .standardized-slide,
body.cb-text-select .standardized-slide * {
  user-select: text;
  -webkit-user-select: text;
}

body {
  font-family: var(--font-primary);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--bg-base);
  color: var(--text-primary);
  min-height: 100vh;
  overflow-y: auto; /* Page-level scrollbar; Chat & Graph opt out via overflow:hidden on their containers */
  line-height: var(--leading-normal);
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

a {
  color: #60a5fa;
  text-decoration: none;
  transition: color 0.2s ease;
}

a:hover {
  color: #93c5fd;
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAMA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;;;;8DAK8D;AAC9D;;;;;;;;;;;;;;;;;;EAkBE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;;uCAGuC;AACvC;;;;;;;;;;;;;;EAcE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,kCAAkC;EAClC,gCAAgC;EAChC,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB,EAAE,uFAAuF;EACzG,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB","sourcesContent":["@import './styles/design-tokens.css';\n@import './styles/dlc-tokens.css';\n@import './styles/modal-variants.css';\n@import './styles/modal-toolbar.css';\n@import './styles/mobile.css';\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n*:not(input):not(textarea):not([contenteditable=\"true\"]) {\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n/* Always-on text selection for lesson bodies + concept card bodies + slide\n   content tables. Edward 2026-05-24: \"make all the content copy-able.\"\n   The global `* { user-select: none }` reset above is intentional for\n   game-UI surfaces (cards, pills, dashboard chrome), but study content\n   (the actual lesson text and table cells the user is reading) must be\n   selectable so it can be copied to notes / external tools. */\n.ls-content-body,\n.ls-content-body *,\n.ls-content-title,\n.ls-key-points,\n.ls-key-points *,\n.ls-markdown,\n.ls-markdown *,\n.cc-title,\n.cc-description,\n.cc-origin,\n.cc-meta-strip,\n.cc-meta-strip *,\n.element-table,\n.element-table *,\n.element-table-wrapper,\n.element-table-wrapper *,\n.ls-table,\n.ls-table * {\n  user-select: text;\n  -webkit-user-select: text;\n}\n\n/* Concept builder mode: allow text selection on slide content + every\n   descendant. Without the `*` selectors the global * { user-select: none }\n   reset wins for child elements (ul/li/p/span), making selection invisible\n   even though the wrapper allows it. */\nbody.cb-text-select .slide-content,\nbody.cb-text-select .slide-content *,\nbody.cb-text-select .element-text,\nbody.cb-text-select .element-text *,\nbody.cb-text-select .ls-content-block,\nbody.cb-text-select .ls-content-block *,\nbody.cb-text-select .ls-slide-block,\nbody.cb-text-select .ls-slide-block *,\nbody.cb-text-select .element-definition-list,\nbody.cb-text-select .element-definition-list *,\nbody.cb-text-select .diagram-label,\nbody.cb-text-select .diagram-label *,\nbody.cb-text-select .standardized-slide,\nbody.cb-text-select .standardized-slide * {\n  user-select: text;\n  -webkit-user-select: text;\n}\n\nbody {\n  font-family: var(--font-primary);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--bg-base);\n  color: var(--text-primary);\n  min-height: 100vh;\n  overflow-y: auto; /* Page-level scrollbar; Chat & Graph opt out via overflow:hidden on their containers */\n  line-height: var(--leading-normal);\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\na {\n  color: #60a5fa;\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\na:hover {\n  color: #93c5fd;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
